<template lang="pug">
  v-card(class="mx-auto" width="256" tile)
    div.pl-4.py-4 {{userLoggedIn.fullName}}
    v-divider
    v-list(nav)
      v-list-item-group(color="primary")
        v-list-item(v-for="(item, i) in links" :key="i" @click="onClickItem(item)")
          v-list-item-icon
            v-icon {{ item.icon }}
          v-list-item-content
            v-list-item-title {{ $t(item.name) }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import { AUTH_LOG_USER_OUT, SHOW_PROFILE_DIALOG } from '@/store/action-types'
import { Action } from 'vuex-class'
import { UserDropDownItem, UserDropDownList } from '@/types'
import { CurrentUser } from '@/model/CurrentUser'
import { USER_LOGGED_IN } from '@/store/getter-types'

@Component
export default class UserDropDown extends Vue {
  private links: UserDropDownList = [
    {
      name: 'toolbarPage.profileLabel',
      code: "profile",
      icon: "fa-user-circle"
    },
    {
      name: 'toolbarPage.logoutLabel',
      code: "logout",
      icon: "fa-power-off"
    }
  ]

  @Action(AUTH_LOG_USER_OUT) logUserOut!: { (): Promise<void> }
  @Action(SHOW_PROFILE_DIALOG) showProfileDialog!: { (payload: boolean): Promise<void> }

  get userLoggedIn(): CurrentUser{
    return this.$store.getters[USER_LOGGED_IN]
  }

  onClickItem ( item: UserDropDownItem): void {

    if(item && item.code == "logout")
    {
      this.logUserOut()
      this.$router.push('/login')
    } else if(item && item.code == "profile") {
      this.showProfileDialog(true)
    }

    this.$emit('closeMenu')
  }
}
</script>

<style lang="stylus" scoped>

</style>
